export const IMPACT_BACKEND_FIELDS = {
  accountability: 'impact_accountability',
  availability: 'impact_availability',
  confidentiality: 'impact_confidentiality',
  integrity: 'impact_integrity'
};

export const translateVirtualFilter = (filter) => {
  if (filter.name === 'impact') {
    const translatedName = IMPACT_BACKEND_FIELDS[filter.op];

    if (!translatedName) return filter;

    return {
      name: translatedName,
      op: '==',
      val: filter.val
    };
  }

  return filter;
};

export const buildTranslatedFilterGroup = (group = []) => {
  const translatedGroup = group.map(translateVirtualFilter);

  if (translatedGroup.length === 1) return translatedGroup[0];

  const hasDateFilter = translatedGroup.some((filter) => filter.name.includes('date'));
  const allNegativeFilters = translatedGroup.every((filter) => ['!=', 'not_any', 'is_not_one_of'].includes(filter.op));

  if (hasDateFilter || allNegativeFilters) return { and: translatedGroup };

  return { or: translatedGroup };
};
